export default "__VITE_ASSET__4fcb1d8c__"